import * as Yup from 'yup'

export const SigninSchema = Yup.object().shape({
  email: Yup.string().email('invalid').required('required'),
  password: Yup.string().min(6, 'minchar').required('required')
})
